import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/ui/button';

interface ChatErrorProps {
  onRetry?: () => void;
  isVideoMode?: boolean;
}

const ChatError: React.FC<ChatErrorProps> = ({ onRetry, isVideoMode }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-start gap-3 px-1 py-2">
      <div className="flex-1 max-w-[90%]">
        <div className="bg-destructive/10 text-destructive rounded-lg px-4 py-3">
          <p className="text-sm">
            {isVideoMode
              ? t(
                  'chat.error.videoMessage',
                  'Failed to analyze the video content.',
                )
              : t('chat.error.message', 'Failed to get a response.')}
          </p>
          {onRetry && (
            <Button
              onClick={onRetry}
              size="sm"
              variant="ghost"
              className="mt-2 h-7 px-2 text-destructive hover:text-destructive hover:bg-destructive/20"
            >
              <RefreshCw className="mr-1.5 h-3 w-3" />
              {t('chat.error.retry', 'Try Again')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatError;
